import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import React from "react";

type RoundedIconButtonProps = React.PropsWithChildren<{
  onClick: VoidFunction;
  backgroundColor: string;
  "data-name": string;
}>;

export default function RoundedIconButton({
  onClick,
  backgroundColor,
  children,
  "data-name": dataName,
}: RoundedIconButtonProps) {
  return (
    <button
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: RAW_cssValue(backgroundColor),
        borderRadius: "dt_radius_round",
        border: "none",
        padding: RAW_cssValue("10px"),
        outlineColor: "transparent",
      }}
      onClick={onClick}
      data-name={dataName}
    >
      {children}
    </button>
  );
}
